export const PROGRESSIVE_PLANS_SUCCESS = 'PROGRESSIVE_PLANS_SUCCESS';
export const PROGRESSIVE_PLANS_FAILURE = 'PROGRESSIVE_PLANS_FAILURE';
export const PROGRESSIVE_PLANS_API = 'PROGRESSIVE_PLANS_API';
export const ADDFEATURE_PERK = 'ADDFEATURE_PERK';
export const CBAND_FED = 'CBAND_FED';
export const PROGRESSIVE_PLANS_MOCK = 'PROGRESSIVE_PLANS_MOCK';
export const FEEDBACK_API = 'FEEDBACK_API';
export const UPDATE_FEEDBACK_API = 'UPDATE_FEEDBACK_API';
export const UPDATE_SELECT_DATA_PERK = `UPDATE_SELECT_DATA_PERK`;
export const UPDATE_PERK_DISCLOSURE = `UPDATE_PERK_DISCLOSURE`;
export const DUPLICATE_PERK_DISCLOSURE = `DUPLICATE_PERK_DISCLOSURE`;
export const UPDATE_SELECT_DATA_PLAN = `UPDATE_SELECT_DATA_PLAN`;
export const UPDATE_PERK_MULTIPLE_DISCLOSURE = `UPDATE_PERK_MULTIPLE_DISCLOSURE`;
export const UPDATE_SELECT_DATA_PERK_INFO = 'UPDATE_SELECT_DATA_PERK_INFO';
export const CLEAR_PLAN_FROM_MARKER = 'CLEAR_PLAN_FROM_MARKER';
export const UPDATE_FROM_PROGRESSIVE = 'UPDATE_FROM_PROGRESSIVE';
export const UPDATE_SELECT_DATA_PLAN_PERK = 'UPDATE_SELECT_DATA_PLAN_PERK';
export const UPDATE_ERROR_NOTIFICATION = 'UPDATE_ERROR_NOTIFICATION';
export const UPDATE_ERROR_NOTIFICATION_PERK = 'UPDATE_ERROR_NOTIFICATION_PERK';
export const SET_PERK_PDP_OVERLAY = 'SET_PERK_PDP_OVERLAY';
export const PERK_DETAILS_MOCK = 'PERK_DETAILS_MOCK';
export const FCC_LABEL = 'FCC_LABEL';
export const PERKS_MODAL_DETAILS_API = 'PERKS_MODAL_DETAILS_API';
export const DUPLICATE_MODEL_API = 'DUPLICATE_MODEL_API';
export const DUPLICATE_MODEL_API_SUCCESS = 'DUPLICATE_MODEL_API_SUCCESS';
export const DUPLICATE_MODEL_API_FAILURE = 'DUPLICATE_MODEL_API_FAILURE';
export const PERKS_MODAL_DETAILS_SUCCESS = 'PERKS_MODAL_DETAILS_SUCCESS';
export const PERKS_MODAL_DETAILS_FAILURE = 'PERKS_MODAL_DETAILS_FAILURE';
export const ADD_PLAN_API = 'ADD_PLAN_API';
export const ADD_PLAN_SUCCESS = 'ADD_PLAN_SUCCESS';
export const UPDATE_AUTO_PAY = 'UPDATE_AUTO_PAY';
export const UPDATE_AUTO_PAY_STATUS = 'UPDATE_AUTO_PAY_STATUS';
export const SET_TERMS_AND_CONDITIONS_OVERLAY = 'SET_TERMS_AND_CONDITIONS_OVERLAY';
export const SET_PERKS_TERMS_AND_CONDITIONS_OVERLAY = 'SET_PERKS_TERMS_AND_CONDITIONS_OVERLAY';
export const UPDATE_PLANS_ACCORD_STATUS = 'UPDATE_PLANS_ACCORD_STATUS';
export const UPDATE_SPECIAL_OFFER_PLAN = 'UPDATE_SPECIAL_OFFER_PLAN';
export const READDL_SUCCESS = 'READDL_SUCCESS';
export const REMOVE_DUPLICATE_PERKS = 'REMOVE_DUPLICATE_PERKS';
export const PERKS_CONFLICT_OVERLAY = 'PERKS_CONFLICT_OVERLAY';
export const NETFLIX_PLUSPLAY_OVERLAY = 'NETFLIX_PLUSPLAY_OVERLAY';
export const NETFLIX_PLUSPLAY_OVERLAY_VALUE = 'NETFLIX_PLUSPLAY_OVERLAY_VALUE';
export const UPDATE_CHOICE_PERK = 'UPDATE_CHOICE_PERK';
export const UPDATE_LQ_LOADED = 'UPDATE_LQ_LOADED';
export const UPDATE_PREV_TOGGLE_EXPLORE = 'UPDATE_PREV_TOGGLE_EXPLORE';
export const ENABLE_CHOICE_OFFER = 'ENABLE_CHOICE_OFFER';
export const CHOICE_OFFER_PROMO_ID = 'CHOICE_OFFER_PROMO_ID';
export const PLAN_CHANGED_FROM_ABANDED = 'PLAN_CHANGED_FROM_ABANDED';
export const ADD_PLAN_API_CALLED = 'ADD_PLAN_API_CALLED';
export const ABANDON_DISCOUNT_OFFER_APPILED = 'ABANDON_DISCOUNT_OFFER_APPILED';
export const SET_STREAMLINE_ORDERING = 'SET_STREAMLINE_ORDERING';
export const SET_STREAMLINE_PERK_REDESIGN = 'SET_STREAMLINE_PERK_REDESIGN';
export const UPSELL_MODAL_UPGRADE_OFFER_CLICKED = 'UPSELL_MODAL_UPGRADE_OFFER_CLICKED';
export const GIFT_CARD_OFFER_MODAL_CLICKED = 'GIFT_CARD_OFFER_MODAL_CLICKED';
export const GIFT_CARD_OFFER_SELECTED_RESET = 'GIFT_CARD_OFFER_SELECTED_RESET';
export const GIFT_CARD_OFFER_LINK_CLICKED = 'GIFT_CARD_OFFER_LINK_CLICKED';
export const SHOW_PERK_SAVING_NOTIFY = 'SHOW_PERK_SAVING_NOTIFY';
export const NC_CHECKOUT_SELECTED_PERKS_ADD = 'NC_CHECKOUT_SELECTED_PERKS_ADD';
export const NC_CHECKOUT_SELECTED_PERKS_REMOVE = 'NC_CHECKOUT_SELECTED_PERKS_REMOVE';
export const SET_VHDP_MODAL = 'SET_VHDP_MODAL';
export const SPECIAL_GIFTSECTION_NOTIFICATION = 'SPECIAL_GIFTSECTION_NOTIFICATION';
export const BROWSER_BACK_REDIRECT_INCREMENT_COUNTER = 'BROWSER_BACK_REDIRECT_INCREMENT_COUNTER';
export const BROWSER_BACK_REDIRECT_RESET_COUNTER = 'BROWSER_BACK_REDIRECT_RESET_COUNTER';
export const SELECTED_PERK_BUNDLE_STATE = 'SELECTED_PERK_BUNDLE_STATE';
export const SET_PERK_BUNDLE_NOTIFICATION = 'SET_PERK_BUNDLE_NOTIFICATION';
export const PERK_BUNDLE_NOTIFICATION_OPENED = 'PERK_BUNDLE_NOTIFICATION_OPENED';
export const SPECIAL_GIFT_NOTIFICATION_ID = 'specialGiftNotificationID';